module.exports = __webpack_public_path__ + "static/media/lk-cargills-store.270a2747.png";